import React from "react";
interface Props {
  dotnumber: number;
  hit: string;
}

const ShootingDot = ({ dotnumber, hit }: Props) => {

  return (
    <div className="shooting-target-dot" style={{marginLeft: (((dotnumber - 1) * 21) + 8)}}>
      {hit === "1" ? <div className="shooting-target-dot-hit"></div> : <>&nbsp;</>}
    </div>
  );
};

export default ShootingDot;
